import { useAtomValue as m, useSetAtom as o } from "jotai";
import { paymentAtom as n, setPaymentAtom as s } from "./index57.mjs";
const p = () => {
  const t = m(n), e = o(s);
  return {
    payment: t,
    setPayment: e
  };
};
export {
  p as usePayment
};
